export const MY_NETWORKING_SELECTOR_STATUS = 'status';

export const MY_NETWORKING_STATUS_LOADING = 'loading';
export const MY_NETWORKING_STATUS_ERROR = 'error';
export const MY_NETWORKING_STATUS_READY = 'ready';

export const MY_NETWORKING_COMMENT_TYPE = 'Chatgroupcomment';
